import seMessages from "../locales/sv_SE.json";

const SeLang = {
  messages: {
    ...seMessages
  },
  locale: 'sv-SE',
};
export default SeLang;
